import React, { useState, useEffect } from "react";
import { Drawer, DrawerProps, createStyles } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { DrawerFooter } from "./DrawerFooter";
import { DrawerBody } from "./DrawerBody";
import { DrawerHeader } from "./DrawerHeader";
import { DrawerEditor } from "./DrawerEditor";

const useStyles = createStyles((theme, _params, getRef) => ({
  drawer: {
    display: "flex",
    flexDirection: "column",
  },

  header: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 70,
    padding: 15,
  },

  body: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  content: {
    height: "100%",
    position: "relative",
  },
}));

export interface IModirDrawerProps<T> extends Omit<DrawerProps, "opened"> {
  drawerId: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
  opened: boolean;
  onClose: () => void;
  form?: UseFormReturnType<T>;
  //onSubmit?: () => void;
  withForm?: boolean;
  loading?: boolean;
  formId?: string;
}

export interface IModirDrawer {
  opened: boolean;
  onClose: () => void;
}

export const ModirDrawer = <T extends unknown>({
  opened,
  title,
  children,
  onClose,
  form,
  //onSubmit,
  withForm,
  loading,
  formId,
  drawerId,
  ...rest
}: IModirDrawerProps<T>) => {
  const { classes } = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(opened);
  }, [opened]);

  return (
    <>
      <Drawer.Root
        opened={isOpen}
        onClose={onClose}
        withCloseButton={false}
        closeOnClickOutside={false}
        overlayProps={{ opacity: 0.5 }}
        classNames={classes}
        {...rest}
      >
        <Drawer.Overlay />
        <Drawer.Content>{children}</Drawer.Content>
      </Drawer.Root>
    </>
  );
};

ModirDrawer.displayName = "@modir/ui-admin/Drawer";
ModirDrawer.Editor = DrawerEditor;
ModirDrawer.Body = DrawerBody;
ModirDrawer.Footer = DrawerFooter;
ModirDrawer.Header = DrawerHeader;
